import * as React from 'react';
import translate from '../../../../locale/translate';

import { CheckboxInput } from '../../common/Input';
import { NodeTagFilterEditor, NodeSystemFilterEditor } from '../../common/Editor';
import ISettings from '../eventCommon/ISettings';
import { IInputChangeEventHandler } from '../../../../interfaces';
import { Tag } from '../../../../store/models';

import { getDisplayValue, formatDate } from '../../util/StringUtil';

interface IProps {
    data: { tags: Tag[] },
    settings: ISettings,
    handleChange: IInputChangeEventHandler,
}

export default class Editor extends React.Component<IProps, void> {
    handleChange(evt: React.ChangeEvent<HTMLInputElement>) {
        this.props.handleChange(evt.target.name, evt.target.checked);
    }

    render() {
        const { settings, handleChange } = this.props;
        const now = new Date();

        return (
            <div>
                <h3>{translate.gettext('Filter')}</h3>

                <NodeTagFilterEditor {...this.props} />

                <h3>{translate.gettext('Columns')}</h3>
                <CheckboxInput
                    name="displaySystemName"
                    label={translate.gettext("Name")}
                    checked={settings.displaySystemName}
                    onChange={this.handleChange.bind(this)}
                />

                <CheckboxInput
                    name="displayMalwareCategory"
                    label={translate.gettext("Thread category")}
                    checked={settings.displayMalwareCategory}
                    onChange={this.handleChange.bind(this)}
                />

                <CheckboxInput
                    name="displayMalwareName"
                    label={translate.gettext("Thread name")}
                    checked={settings.displayMalwareName}
                    onChange={this.handleChange.bind(this)}
                />

                <CheckboxInput
                    name="displayModule"
                    label={translate.gettext("Thread detection module")}
                    checked={settings.displayModule}
                    onChange={this.handleChange.bind(this)}
                />

                <CheckboxInput
                    name="displayTimestamp"
                    label={translate.gettext("Event timestamp")}
                    checked={settings.displayTimestamp}
                    onChange={this.handleChange.bind(this)}
                />
            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./src/components/widget/mav/listEventDays/Editor.tsx